import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=7397f6d8&scoped=true&"
import script from "./Footnote.vue?vue&type=script&lang=js&"
export * from "./Footnote.vue?vue&type=script&lang=js&"
import style0 from "./Footnote.vue?vue&type=style&index=0&id=7397f6d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7397f6d8",
  null
  
)

export default component.exports